import React from 'react'

const CovidRapidTesting = () => {
  return (
    <div id='website-responsive'>
    <div className='left-padding5rem1 right-padding5rem1 py-md-5 py-4 bg-img' style={{ backgroundImage:"url('rsv-testing/ULC-Testing-bg-v1.png')", height:'100%', width:'100%'}}>
        <div className='pb-3'>
            <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                *Free Rapid Covid Testing In Chicago
            </div>
            <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
        </div>

        <div className='pb3'>
            <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
            United Lab Care provides you with the COVID-19 testing services in Chicago without any cost to you. You will not be charged a copay or deductible because we will bill your insurance. Although, your health insurance plan may refuse to pay for the test if you only want it for covid testing and not for diagnosis. However, if you are uninsured, the HRSA program of the federal government will pay for your test.
            
            </div>
        </div>

            <div className='pb-4'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                In case of further queries, don’t hesitate to contact your health insurance provider for more information.
                </div>
            </div>

        <div className=''>
            <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
            If you are traveling have a rapid RT PCR test, or have just come back from a tour and are worried about Delta Virus or the other variants, make an appointment today for a COVID test at a United Lab Care testing place near you in Chicago.
            </div>
        </div>

        <div className='pb-4'>
            <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                Your safe health is our priority. Make it yours too!
            </div>
        </div>

        <div className=''>
            <div className='fs-ss-16 text-montserrat fw-700 text-ss-secondary' style={{ letterSpacing:'0.5px'}}>
                *Free means no cost to you but not free in general.
            </div>
        </div>
    </div>
</div>
  )
}

export default CovidRapidTesting